/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useRef } from 'react';

import { makeStyles, Typography } from '@material-ui/core';

import { ReactComponent as IconShare } from '../../assets/images/ic-share.svg';

const useStyles = makeStyles((theme) => ({
  buttonInteractionText: {
    color: theme.palette.primary.main,
    fontSize: '14px',
    lineHeight: '18px',
    marginBottom: '0px',
  },
  iconInteraction: {
    height: '16px',
    marginRight: '5px',
    width: '16px',
  },
  iconInteractionShare: {
    stroke: theme.palette.primary.main,
  },
  link: {
    color: '#388E3C',
    fontSize: '0.875rem',
  },
  popup: {
    background: '#FFFFFF',
    border: '1px solid #E7E7E7',
    borderRadius: '5px',
    boxShadow: '2px 6px 10px rgba(0, 0, 0, 0.1)',
    boxSizing: 'border-box',
    padding: '0.2rem',
    position: 'fixed',
    zIndex: 200,
  },
}));
export default ({ link, onShareVideoReport }) => {
  const classes = useStyles();
  const elementRef = useRef();

  const handleShareClick = (event) => {
    if (link?.id) {
      onShareVideoReport(link.id);
    }
    event.preventDefault();
    event.stopPropagation();
    return false;
  };

  return (
    <div ref={elementRef} style={{ display: 'inline-block', position: 'relative' }}>
      <div onClick={handleShareClick} style={{ alignItems: 'center', cursor: 'pointer', display: 'flex' }}>
        <IconShare className={`${classes.iconInteraction} ${classes.iconInteractionShare}`} />
        <Typography className={classes.buttonInteractionText}>Share</Typography>
      </div>
    </div>
  );
};
